import FinancingHelper from "../../../../helpers/FinancingHelper";

export default function TotalDiv({ totalArray, name }) {
  return (
    <div className="flex items-center mt-2">
      <div
        className="whitespace-nowrap flex items-center border-t py-4"
        style={{ minWidth: "40em" }}
      >
        <label className="font-semibold">
          Total Cash From {name}
        </label>
      </div>
      <div className="flex border-t py-4">
        {totalArray?.map((obj) => (
          <div
            className="flex items-center"
            style={{ minWidth: "10em" }}
          >
            <label
              className={
                obj?.disabled
                  ? "disabled font-semibold"
                  : "font-semibold"
              }
            >
              {FinancingHelper.bracketFormatter(obj?.value)}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
